import { Clock } from 'lucide-react'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import { colors } from '@/utils/theme'

dayjs.extend(localizedFormat)

interface TimestampProps {
  from: string
  to?: string | null
  noIcon?: boolean
  showTime?: boolean
  size?: 'normal' | 'large'
}

function Timestamp({
  from,
  to,
  noIcon,
  showTime = true,
  size = 'normal'
}: TimestampProps) {
  const format = showTime ? 'L LT' : 'L'

  const renderDate = (date: string) => dayjs(date).format(format)

  return (
    <Flex inline align='center' gap={2}>
      {!noIcon && <Clock size={18} style={{ color: colors['black-light-40'] }} />}
      <Text
        variant={size === 'large' ? 'text' : 'footnote'}
        color='black-light-40'
      >
        {renderDate(from)}
        {to && (
          <>
            {' '}•{' '}
            {renderDate(to)}
          </>
        )}
      </Text>
    </Flex>
  )
}

export default Timestamp
